import { addFilter } from '@wordpress/hooks';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, SelectControl } from '@wordpress/components';
import { Fragment } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { createHigherOrderComponent } from '@wordpress/compose';


// Inside the addCustomToolbarControl function, add InspectorControls
const addCustomToolbarControl = (BlockEdit) => (props) => {

    const { attributes, setAttributes, clientId } = props;

    return (
        <Fragment>
            <BlockEdit {...props} />
            <InspectorControls>
                <PanelBody title={__('Block Animation', 'blockmotion')}>
                    <SelectControl
                        __next40pxDefaultSize
                        __nextHasNoMarginBottom
                        label="Select an Animation"
                        value={attributes.animation_name}
                        onChange={(value) => { setAttributes({ animation_name: value }) }}
                        options={[
                            { label: 'None', value: 'none' },
                            { label: 'Bounce', value: 'bounce' },
                            { label: 'Flash', value: 'flash' },
                            { label: 'Pulse', value: 'pulse' },
                            { label: 'Rubber Band', value: 'rubberBand' },
                            { label: 'Shake X', value: 'shakeX' },
                            { label: 'Shake Y', value: 'shakeY' },
                            { label: 'Head Shake', value: 'headShake' },
                            { label: 'Swing', value: 'swing' },
                            { label: 'Tada', value: 'tada' },
                            { label: 'Wobble', value: 'wobble' },
                            { label: 'Jello', value: 'jello' },
                            { label: 'Heart Beat', value: 'heartBeat' },

                            // Back Entrances
                            { label: 'Back In Down', value: 'backInDown' },
                            { label: 'Back In Left', value: 'backInLeft' },
                            { label: 'Back In Right', value: 'backInRight' },
                            { label: 'Back In Up', value: 'backInUp' },

                            // Back Exits
                            { label: 'Back Out Down', value: 'backOutDown' },
                            { label: 'Back Out Left', value: 'backOutLeft' },
                            { label: 'Back Out Right', value: 'backOutRight' },
                            { label: 'Back Out Up', value: 'backOutUp' },

                            // Bouncing Entrances
                            { label: 'Bounce In', value: 'bounceIn' },
                            { label: 'Bounce In Down', value: 'bounceInDown' },
                            { label: 'Bounce In Left', value: 'bounceInLeft' },
                            { label: 'Bounce In Right', value: 'bounceInRight' },
                            { label: 'Bounce In Up', value: 'bounceInUp' },

                            // Bouncing Exits
                            { label: 'Bounce Out', value: 'bounceOut' },
                            { label: 'Bounce Out Down', value: 'bounceOutDown' },
                            { label: 'Bounce Out Left', value: 'bounceOutLeft' },
                            { label: 'Bounce Out Right', value: 'bounceOutRight' },
                            { label: 'Bounce Out Up', value: 'bounceOutUp' },

                            // Fading Entrances
                            { label: 'Fade In', value: 'fadeIn' },
                            { label: 'Fade In Down', value: 'fadeInDown' },
                            { label: 'Fade In Down Big', value: 'fadeInDownBig' },
                            { label: 'Fade In Left', value: 'fadeInLeft' },
                            { label: 'Fade In Left Big', value: 'fadeInLeftBig' },
                            { label: 'Fade In Right', value: 'fadeInRight' },
                            { label: 'Fade In Right Big', value: 'fadeInRightBig' },
                            { label: 'Fade In Up', value: 'fadeInUp' },
                            { label: 'Fade In Up Big', value: 'fadeInUpBig' },
                            { label: 'Fade In Top Left', value: 'fadeInTopLeft' },
                            { label: 'Fade In Top Right', value: 'fadeInTopRight' },
                            { label: 'Fade In Bottom Left', value: 'fadeInBottomLeft' },
                            { label: 'Fade In Bottom Right', value: 'fadeInBottomRight' },

                            // Fading Exits
                            { label: 'Fade Out', value: 'fadeOut' },
                            { label: 'Fade Out Down', value: 'fadeOutDown' },
                            { label: 'Fade Out Down Big', value: 'fadeOutDownBig' },
                            { label: 'Fade Out Left', value: 'fadeOutLeft' },
                            { label: 'Fade Out Left Big', value: 'fadeOutLeftBig' },
                            { label: 'Fade Out Right', value: 'fadeOutRight' },
                            { label: 'Fade Out Right Big', value: 'fadeOutRightBig' },
                            { label: 'Fade Out Up', value: 'fadeOutUp' },
                            { label: 'Fade Out Up Big', value: 'fadeOutUpBig' },
                            { label: 'Fade Out Top Left', value: 'fadeOutTopLeft' },
                            { label: 'Fade Out Top Right', value: 'fadeOutTopRight' },
                            { label: 'Fade Out Bottom Right', value: 'fadeOutBottomRight' },
                            { label: 'Fade Out Bottom Left', value: 'fadeOutBottomLeft' },

                            // Flippers
                            { label: 'Flip', value: 'flip' },
                            { label: 'Flip In X', value: 'flipInX' },
                            { label: 'Flip In Y', value: 'flipInY' },
                            { label: 'Flip Out X', value: 'flipOutX' },
                            { label: 'Flip Out Y', value: 'flipOutY' },

                            // Lightspeed
                            { label: 'Light Speed In Right', value: 'lightSpeedInRight' },
                            { label: 'Light Speed In Left', value: 'lightSpeedInLeft' },
                            { label: 'Light Speed Out Right', value: 'lightSpeedOutRight' },
                            { label: 'Light Speed Out Left', value: 'lightSpeedOutLeft' },

                            // Rotating Entrances
                            { label: 'Rotate In', value: 'rotateIn' },
                            { label: 'Rotate In Down Left', value: 'rotateInDownLeft' },
                            { label: 'Rotate In Down Right', value: 'rotateInDownRight' },
                            { label: 'Rotate In Up Left', value: 'rotateInUpLeft' },
                            { label: 'Rotate In Up Right', value: 'rotateInUpRight' },

                            // Rotating Exits
                            { label: 'Rotate Out', value: 'rotateOut' },
                            { label: 'Rotate Out Down Left', value: 'rotateOutDownLeft' },
                            { label: 'Rotate Out Down Right', value: 'rotateOutDownRight' },
                            { label: 'Rotate Out Up Left', value: 'rotateOutUpLeft' },
                            { label: 'Rotate Out Up Right', value: 'rotateOutUpRight' },

                            // Specials
                            { label: 'Hinge', value: 'hinge' },
                            { label: 'Jack In The Box', value: 'jackInTheBox' },
                            { label: 'Roll In', value: 'rollIn' },
                            { label: 'Roll Out', value: 'rollOut' },

                            // Zooming Entrances
                            { label: 'Zoom In', value: 'zoomIn' },
                            { label: 'Zoom In Down', value: 'zoomInDown' },
                            { label: 'Zoom In Left', value: 'zoomInLeft' },
                            { label: 'Zoom In Right', value: 'zoomInRight' },
                            { label: 'Zoom In Up', value: 'zoomInUp' },

                            // Zooming Exits
                            { label: 'Zoom Out', value: 'zoomOut' },
                            { label: 'Zoom Out Down', value: 'zoomOutDown' },
                            { label: 'Zoom Out Left', value: 'zoomOutLeft' },
                            { label: 'Zoom Out Right', value: 'zoomOutRight' },
                            { label: 'Zoom Out Up', value: 'zoomOutUp' },

                            // Sliding Entrances
                            { label: 'Slide In Down', value: 'slideInDown' },
                            { label: 'Slide In Left', value: 'slideInLeft' },
                            { label: 'Slide In Right', value: 'slideInRight' },
                            { label: 'Slide In Up', value: 'slideInUp' },

                            // Sliding Exits
                            { label: 'Slide Out Down', value: 'slideOutDown' },
                            { label: 'Slide Out Left', value: 'slideOutLeft' },
                            { label: 'Slide Out Right', value: 'slideOutRight' },
                            { label: 'Slide Out Up', value: 'slideOutUp' }
                        ]}
                    />
                </PanelBody>
            </InspectorControls>
        </Fragment>
    );
};

addFilter(
    'editor.BlockEdit',
    'custom-paragraph-control/toolbar',
    addCustomToolbarControl
);


function addCustomAttribute(settings, name) {

    if (!settings.attributes) {
        return settings;
    }

    settings.attributes = {
        ...settings.attributes,
        animation_name: {
            type: 'string',
            default: 'none',
        },
    };

    return settings;
}

addFilter(
    'blocks.registerBlockType',
    'my-plugin/add-custom-attribute',
    addCustomAttribute
);


function addExtraClassName(extraProps, blockType, attributes) {

    const { animation_name } = attributes;

    const addAnimationClass = () => {
        if (animation_name && animation_name !== 'none') {
            return 'animate-on-scroll animate__animated';
        }
        return '';
    }

    const existingClass = extraProps.className || '';

    extraProps.className = `${existingClass} ${addAnimationClass()}`.trim();

    if (animation_name && animation_name !== 'none') {
        extraProps['data-animation'] = animation_name;
    }

    return extraProps;
}


addFilter(
    'blocks.getSaveContent.extraProps',
    'my-plugin/add-extra-class',
    addExtraClassName
);


// Add the class inside editor too
const withAnimationClassInEditor = createHigherOrderComponent((BlockListBlock) => {
    return (props) => {

        const { attributes } = props;
        const { animation_name } = attributes;


        const animationClass =
            animation_name && animation_name !== 'none'
                ? `animate__animated animate__${animation_name}`
                : '';

        const existingClass = props.className || '';

        return <BlockListBlock {...props} className={`${existingClass} ${animationClass}`.trim()} />;
    };
}, 'withAnimationClassInEditor');

addFilter(
    'editor.BlockListBlock',
    'custom-paragraph-control/editor-class',
    withAnimationClassInEditor
);


document.addEventListener("DOMContentLoaded", function () {

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const animation = entry.target.dataset.animation;
                if (animation) {
                    entry.target.classList.add(`animate__${animation}`);
                }
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1
    });

    document.querySelectorAll('.animate-on-scroll').forEach(elem => {
        observer.observe(elem);
    });
});
